import firebase from 'firebase/app';
import 'firebase/messaging';
import { isIOS } from 'react-device-detect';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

// Initialize Firebase
if (firebase.messaging.isSupported() && !isIOS) {
  console.log('init firebase');
  firebase.initializeApp(firebaseConfig);
}

export const askForPermissioToReceiveNotifications = async () => {
  try {
    const messaging = firebase.messaging();
    await messaging.requestPermission();
    const token = await messaging.getToken();
    console.log(`firebaseToken:${token}`);
    localStorage.setItem('firebaseToken', token);
  } catch (error) {
    console.error(error);
  }
};

export const onMessageListener = () =>
  new Promise(resolve => {
    const messaging = firebase.messaging();
    messaging.onMessage(payload => {
      resolve(payload);
    });
  });
